export interface RateDto {
    rateId?: number;
    organizationId?: number;
    accountingItemId?: number | undefined;
    amendmendNumber?: string | undefined;
    applyToDestinationCountry?: boolean | undefined;
    applyToOriginCountry?: boolean | undefined;
    automaticallyCreateCharge?: boolean;
    carrierId?: number | undefined;
    clientId?: number | undefined;
    commodityTypeId?: number | undefined;
    contractNumber?: string | undefined;
    countryOfDestinationCode?: string | undefined;
    countryOfOriginCode?: string | undefined;
    currencyId?: number | undefined;
    effectiveDate?: Date | undefined;
    expirationDate?: Date | undefined;
    portOfDeliveryId?: string | undefined;
    portOfLoadingId?: string | undefined;
    portOfReceiptId?: string | undefined;
    portOfUnloadingId?: string | undefined;
    serviceType?: ServiceType;
    tariff?: TariffOptions;
    transitDaysMin?: number | undefined;
    transitDaysMax?: number | undefined;
    modeOfTransportation?: ModeOfTransportationDto;
    carrier?: ContactDto;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date;
    lastModifiedBy?: string | undefined;
    createdByUserName?: string | undefined;
    lastModifiedByUserName?: string | undefined;
    customValues?: { [key: string]: string } | undefined;
}

export interface ModeOfTransportationDto {
    modeOfTransportationId: number;
    created?: Date;
    createdBy?: string | undefined;
    description: string;
    organizationId: number;
    transportationMethod: TransportationMethod;
    transportationMethodDescription: TransportationMethodDescription;
    usCustomsCode: string;
    lastModified?: Date;
    lastModifiedBy?: string | undefined;
    customValues?: object | undefined;
}

export interface ContactDto {
    contactId?: number;
    accountNumber?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    createdByUserName?: string | undefined;
    divisionId?: number;
    divisionName?: string;
    emailAddress?: string | undefined;
    faxNumber?: string | undefined;
    idNumber?: string | undefined;
    lastModified?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedByUserName?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    name?: string | undefined;
    customValues?: object | undefined;
    contactStatusId?: number | undefined;
    tags?: string[] | undefined;
    isDeleted?: boolean;
}

export enum TransportationMethod {
    Ocean = 'Ocean',
    Rail = 'Rail',
    Ground = 'Ground',
    Air = 'Air',
    Mail = 'Mail',
    Unknown = 'Unknown',
    Pipe = 'Pipe',
}

export enum TransportationMethodDescription {
    Vessel = 'Vessel',
    VesselAndContainerized = 'VesselAndContainerized',
    Barge = 'Barge',

    Rail = 'Rail',
    RailAndContainerized = 'RailAndContainerized',

    Truck = 'Truck',
    TruckAndContainerized = 'TruckAndContainerized',
    Auto = 'Auto',
    Pedestrian = 'Pedestrian',
    RoadAndOther = 'RoadAndOther',

    Air = 'Air',
    AirAndContainerized = 'AirAndContainerized',

    Mail = 'Mail',

    PassengerAndHandCarried = 'PassengerAndHandCarried',

    FixedTransport = 'FixedTransport',
}

export enum ServiceType {
    PortToDoor = 'PortToDoor',
    DoorToDoor = 'DoorToDoor',
    DoorToPort = 'DoorToPort',
    PortToPort = 'PortToPort',
}

export interface TariffOptions {
    maximum?: number | undefined;
    minimum?: number | undefined;
    rateMultiplier?: number | undefined;
    applyBy?: ApplyBy;
    unitType?: Units;
    ratePerType?: RatePerType;
    ratePer?: number | undefined;
    rates?: number[][] | undefined;
    calculatedOf?: CalculatedOf;
    rateData?: RateDataDto[];
}

export enum ApplyBy {
    Pieces = 'Pieces',
    Weight = 'Weight',
    Volume = 'Volume',
    Container = 'Container',
    Calculated = 'Calculated',
}

export enum Units {
    Lb = 'Lb',
    Vlb = 'Vlb',
    Vkg = 'Vkg',
    M = 'M',
}

export enum RatePerType {
    Unit = 'Unit',
    Range = 'Range',
}

export enum CalculatedOf {
    Income = 'Income',
    Expense = 'Expense',
    Profit = 'Profit',
}

export interface RateDataDto {
    rateIndex?: any;
    rateValue: number;
}

export enum WeightUnit {
    Lb = "Lb",
    Kg = "Kg",
}

export enum DimensionsUnit {
    In = "In",
    Cm = "Cm",
}